// Central definition of who counts as "staff" for portal routing/access.
//
// Roles are dynamic — Admins can create custom roles in Roles & Permissions.
// Rather than maintaining a hardcoded allow-list of staff roles (which silently
// locked out custom roles and caused blank pages / "access denied"), we define
// staff as *any authenticated role that is not a customer or investor*.

export const NON_STAFF_ROLES = ['customer', 'investor'];

export const isInvestorRole = (role, roles = []) =>
  role === 'investor' || (Array.isArray(roles) && roles.includes('investor'));

export const isStaffRole = (role) =>
  !!role && !NON_STAFF_ROLES.includes(role);
